import React, { useState } from 'react';
import { Navbar } from '../components/layouts/Navbar';
import { PlannerSidebar } from '../components/layouts/PlannerSidebar';
import { ClienteList } from '../components/crud/ClienteList';
import ClienteFormModal from '../components/crud/ClienteFormModal';
import type { Cliente } from '../types/entities';

export const Clientes: React.FC = () => {
  const [selectedCliente, setSelectedCliente] = useState<Cliente | undefined>();
  const [modalOpen, setModalOpen] = useState(false);
  const [listRefresh, setListRefresh] = useState(0);

  const handleCreateNew = () => {
    setSelectedCliente(undefined);
    setModalOpen(true);
  };

  const handleEdit = (cliente: Cliente) => {
    setSelectedCliente(cliente);
    setModalOpen(true);
  };

  const handleSuccess = () => {
    setModalOpen(false);
    setSelectedCliente(undefined);
    // sinaliza para a lista recarregar
    setListRefresh((v) => v + 1);
  };

  const handleCancel = () => {
    setModalOpen(false);
    setSelectedCliente(undefined);
  };

  return (
    <div className="min-h-screen" style={{ backgroundColor: '#F4EFFA' }}>
      <Navbar />
      <div className="flex p-4 gap-2">
        <div className="flex-1">
          {/* Header */}
          <div className="flex justify-between items-center mb-2">
            <div>
              <h1 className="text-xs font-bold" style={{ color: '#3d2b56' }}>
                Gestão de Clientes
              </h1>
              <p className="text-xs mt-0.5" style={{ color: '#9E9E9E' }}>
                Gerencie os clientes do sistema
              </p>
            </div>
            
            <button
              onClick={handleCreateNew}
              className="px-3 py-1 text-xs font-medium text-white rounded-md hover:opacity-80 focus:outline-none focus:ring-1 focus:ring-offset-1 transition-opacity"
              style={{ backgroundColor: '#7A61B2' }}
            >
              + Novo Cliente
            </button>
          </div>

          {/* Conteúdo principal */}
          <div className="bg-white rounded-lg shadow-sm p-4">
            <ClienteList 
              onEdit={handleEdit}
              onView={handleEdit} // Por enquanto, "ver" = "editar"
              refreshSignal={listRefresh}
            />
            
            {modalOpen && (
              <ClienteFormModal
                cliente={selectedCliente}
                onClose={handleCancel}
                onSuccess={() => handleSuccess()}
              />
            )}
          </div>
        </div>
        
        <div className="hidden lg:block">
          <PlannerSidebar />
        </div>
      </div>
    </div>
  );
};